export enum AuthBgImageEnum {
    Login,
    SignUp,
    ForgotPassword,
}

export const AUTH_BG_IMAGE = {
    [AuthBgImageEnum.Login]: '/assets/images/login/login-2.png',
    [AuthBgImageEnum.SignUp]: '/assets/images/login/signup-3.png',
    [AuthBgImageEnum.ForgotPassword]: '/assets/images/login/forgot-password-2.png',
};

export function getAuthBgImage(value: AuthBgImageEnum): string {
    const defaultImage = '/assets/images/login/login-2.png';

    return AUTH_BG_IMAGE[value] || defaultImage;
}
